/* mca-related-works.js — M2 Phase 08 / Phase 02
 * Async-fills ML recommendations into [data-rw-ml-mount] via Shopify's
 * Section Rendering API. Server-rendered same-artist tiles are already in DOM.
 * Silent on error (hides empty ML group); deduplicates against same-artist tiles. */
(function () {
  'use strict';

  var section = document.querySelector('[data-mca-related-works]');
  if (!section) return;

  var mount = section.querySelector('[data-rw-ml-mount]');
  if (!mount) return;

  var productId = section.getAttribute('data-product-id');
  var sectionId = section.getAttribute('data-section-id');
  if (!productId || !sectionId) return;

  // Build dedupe set of handles already rendered in same-artist group.
  var existingHandles = new Set();
  section.querySelectorAll('.mca-rw-card[data-handle]').forEach(function (el) {
    var h = el.getAttribute('data-handle');
    if (h) existingHandles.add(h);
  });

  var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId)
          + '&product_id=' + encodeURIComponent(productId)
          + '&limit=8&intent=related';

  function fillRecommendations() {
    mount.setAttribute('data-loading', '');
    mount.hidden = false;

    fetch(url, { credentials: 'same-origin' })
      .then(function (resp) {
        if (!resp.ok) throw new Error('SRA ' + resp.status);
        return resp.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-rw-ml-content]');
        if (!content) {
          hideMount();
          return;
        }

        // Filter out tiles already shown in same-artist group.
        var tiles = content.querySelectorAll('.mca-related-works__item');
        var kept = 0;
        tiles.forEach(function (tile) {
          var card = tile.querySelector('.mca-rw-card');
          var h = card && card.getAttribute('data-handle');
          if (h && existingHandles.has(h)) {
            tile.remove();
          } else {
            kept++;
          }
        });

        if (kept === 0) {
          hideMount();
          return;
        }

        mount.removeAttribute('data-loading');
        mount.replaceWith(content);
        // M2 Phase 12 — notify section's Swiper init that ML group is mounted
        document.dispatchEvent(new CustomEvent('mca-rw:ml-mounted'));
      })
      .catch(function () {
        hideMount();
      });
  }

  function hideMount() {
    var group = section.querySelector('.mca-related-works__group--ml');
    if (group) group.remove();
  }

  // Defer until idle so we never compete with PDP LCP.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fillRecommendations, { timeout: 2000 });
  } else {
    setTimeout(fillRecommendations, 600);
  }
})();
